import { useIntl } from "react-intl";
import "./StarRating.less";
import clsx from "clsx";

type BusinessCardRatingProps = {
   type?: "row" | "column" | "userInfo";
   numberOfOpinions?: number;
   rate: number;
};

const TOTAL_STARS = 5;

export const StarRating = ({ type = "row", rate, numberOfOpinions }: BusinessCardRatingProps) => {
   const intl = useIntl();
   const percentage = (rate / TOTAL_STARS) * 100;
   const fixedRate = Math.round(rate * 100) / 100;

   if (rate === 0) {
      return <p>{intl.formatMessage({ id: "business.noRating" })}</p>;
   }

   const starLayer = (
      <div
         className={clsx(
            "star-rating__stars",
            type === "userInfo" ? "star-rating__stars--small" : "",
         )}
      >
         <div className="star-rating__stars-bg" />
         <div className="star-rating__stars-fg" style={{ width: `${percentage}%` }} />
      </div>
   );

   switch (type) {
      case "userInfo":
         return (
            <div className="star-rating star-rating--left-margin">
               {starLayer}
               <span className="star-rating__user-rate">
                  {fixedRate}/{TOTAL_STARS}
               </span>
            </div>
         );

      case "column":
         return (
            <div className="star-rating star-rating--column">
               <p className="star-rating__text star-rating__text--big">{fixedRate}</p>
               {starLayer}
               <p className="star-rating__text">{`Opinie: ${numberOfOpinions}`}</p>
            </div>
         );

      default:
         return (
            <div className="star-rating">
               <p className="star-rating__text">{fixedRate}</p>
               {starLayer}
               <p className="star-rating__text">({numberOfOpinions})</p>
            </div>
         );
   }
};
